module.exports = __webpack_public_path__ + "img/028-repair.7aa1fb84.svg";